export const formatCurrencyINRFull = (amount: number): string => new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
}).format(Math.round(amount || 0));

export const formatCurrencyINRCompact = (amount: number): string => {
  const value = Number(amount || 0);
  const absolute = Math.abs(value);
  if (absolute >= 10000000) return `₹${(value / 10000000).toFixed(1)}Cr`;
  if (absolute >= 100000) return `₹${(value / 100000).toFixed(1)}L`;
  if (absolute >= 1000) return `₹${(value / 1000).toFixed(1)}K`;
  return `₹${Math.round(value)}`;
};

export const formatDateIN = (value?: string | Date | null): string => {
  if (!value) return '-';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('en-IN', { month: 'short', day: '2-digit', year: 'numeric' });
};

export const formatPercent = (value: number, digits = 1): string => `${value.toFixed(digits)}%`;

export type WorkflowStatus = 'pending' | 'approved' | 'rejected' | 'reimbursed' | 'draft' | 'unknown';

export const normalizeWorkflowStatus = (raw?: string): WorkflowStatus => {
  const value = String(raw || '').toLowerCase();
  if (value === 'pending' || value === 'pending_payment' || value === 'payment_confirmed') return 'pending';
  if (value === 'approved' || value === 'auto_approved' || value === 'manager_approved' || value === 'finance_approved') return 'approved';
  if (value === 'rejected') return 'rejected';
  if (value === 'reimbursed') return 'reimbursed';
  if (value === 'draft') return 'draft';
  return 'unknown';
};

export const workflowStatusLabel = (status: WorkflowStatus): string => {
  if (status === 'pending') return 'Pending';
  if (status === 'approved') return 'Approved';
  if (status === 'rejected') return 'Rejected';
  if (status === 'reimbursed') return 'Reimbursed';
  if (status === 'draft') return 'Draft';
  return 'Unknown';
};

export const workflowStatusTone = (status: WorkflowStatus): 'neutral' | 'positive' | 'warning' | 'danger' => {
  if (status === 'pending' || status === 'draft') return 'warning';
  if (status === 'approved' || status === 'reimbursed') return 'positive';
  if (status === 'rejected') return 'danger';
  return 'neutral';
};
